import LogRocket from 'logrocket';
import React, { Context, createContext } from 'react';
import { AppRootContext } from './AppRootContext';

export const LogRocketContext: Context<typeof LogRocket | null> =
  createContext(null);

type LogRocketProviderProps = {
  children: React.ReactNode;
};

export function LogRocketProvider({ children }: LogRocketProviderProps) {
  return (
    <LogRocketContext.Provider
      value={window.materio?.logrocket?.enabled ? LogRocket : null}
    >
      {children}
    </LogRocketContext.Provider>
  );
}

export function initLogRocketStepOne() {
  if (!window.materio?.logrocket?.enabled) {
    return; // No-Op; LogRocket is disabled
  }

  // Backwards compatibility with CDN (which sets LogRocket on window)
  window.LogRocket = LogRocket;

  LogRocket.init(window.materio.logrocket.appId, {
    network: {
      requestSanitizer: (request) => {
        const url = (request.url || '').toLowerCase();

        // Prevent monitoring tools from causing an infinite "Ping-Pong" by monitoring each other
        if (url.indexOf('api-js.mixpanel.com') !== -1) {
          return null;
        } else if (url.indexOf('ingest.sentry.io') !== -1) {
          return null;
        }

        // if the url contains 'register' or 'login', scrub out the body
        if (url.indexOf('register') !== -1 || url.indexOf('login') !== -1) {
          request.body = null;
        }

        return request; // otherwise log the request normally
      },
    },
  });
}

export function initLogRocketStepTwo(ctx: AppRootContext) {
  if (!window.materio?.logrocket?.enabled) {
    return; // No-Op; LogRocket is disabled
  }

  const { actualUser } = ctx;

  if (actualUser) {
    LogRocket.identify(actualUser.id, {
      name: actualUser.fullName,
      email: actualUser.email,
      userType: actualUser.userType,
    });
  }
}
